module.exports = __webpack_public_path__ + "static/media/wallet_icon.c121627b.svg";